import {
  convertDisplayAmountToStorage,
  convertStorageAmountToDisplay,
} from "../../intl/formatters.js";

const STORAGE_KEY_PREFIX = "automap_buyer_financing_prefs:";

export const ALLOWED_TERM_MONTHS = [12, 24, 36, 48, 60, 72, 84];

export const GUEST_FINANCING_DEFAULTS = {
  downPaymentCop: null,
  termMonths: 60,
  annualInterestRate: 18,
  monthlyPaymentTargetCop: null,
  maxBudgetCop: null,
};

export function loadGuestFinancingPrefs(slug) {
  if (!slug || typeof window === "undefined") return null;
  try {
    const raw = localStorage.getItem(`${STORAGE_KEY_PREFIX}${slug}`);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function saveGuestFinancingPrefs(slug, prefs) {
  if (!slug || typeof window === "undefined") return;
  try {
    localStorage.setItem(`${STORAGE_KEY_PREFIX}${slug}`, JSON.stringify(prefs));
  } catch {
    // ignore quota errors
  }
}

export function clearGuestFinancingPrefs(slug) {
  if (!slug || typeof window === "undefined") return;
  try {
    localStorage.removeItem(`${STORAGE_KEY_PREFIX}${slug}`);
  } catch {
    // ignore
  }
}

export function parseCopInput(value) {
  if (value === "" || value == null) return null;
  const cleaned = String(value).replace(/[^\d]/g, "");
  if (!cleaned) return null;
  const parsed = Number(cleaned);
  return Number.isFinite(parsed) ? parsed : null;
}

export function formatCopInputValue(value) {
  if (value == null || value === "") return "";
  const parsed = Number(value);
  if (!Number.isFinite(parsed)) return "";
  return String(Math.round(parsed));
}

function currencyInputOptions(displayCurrency, ratesOptions = {}) {
  return {
    displayCurrency,
    storageCurrency: "COP",
    rates: ratesOptions.rates,
    ratesAvailable: ratesOptions.ratesAvailable,
  };
}

/** Show a stored COP field value in the active display currency for text inputs. */
export function formatCopFieldForDisplayInput(copFieldValue, displayCurrency, ratesOptions = {}) {
  const cop = parseCopInput(copFieldValue);
  if (cop == null) return "";
  const displayAmount = convertStorageAmountToDisplay(
    cop,
    currencyInputOptions(displayCurrency, ratesOptions)
  );
  return displayAmount == null ? "" : String(displayAmount);
}

/** Parse display-currency input and return a COP string for form state. */
export function parseDisplayInputToCopField(displayValue, displayCurrency, ratesOptions = {}) {
  const parsed = parseCopInput(displayValue);
  if (parsed == null) return "";
  const cop = convertDisplayAmountToStorage(
    parsed,
    currencyInputOptions(displayCurrency, ratesOptions)
  );
  return cop == null ? "" : String(cop);
}

export function financingPrefsToFormState(prefs = {}) {
  return {
    downPaymentCop: formatCopInputValue(prefs.downPaymentCop),
    termMonths: prefs.termMonths ?? GUEST_FINANCING_DEFAULTS.termMonths,
    annualInterestRate:
      prefs.annualInterestRate ?? GUEST_FINANCING_DEFAULTS.annualInterestRate,
    monthlyPaymentTargetCop: formatCopInputValue(prefs.monthlyPaymentTargetCop),
    maxBudgetCop: formatCopInputValue(prefs.maxBudgetCop),
  };
}

export function formStateToFinancingPrefs(form) {
  return {
    downPaymentCop: parseCopInput(form.downPaymentCop),
    termMonths: Number(form.termMonths),
    annualInterestRate: Number(form.annualInterestRate),
    monthlyPaymentTargetCop: parseCopInput(form.monthlyPaymentTargetCop),
    maxBudgetCop: parseCopInput(form.maxBudgetCop),
  };
}
